import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2","key":"svg-0"}],["path",{"d":"M7 9l5 -5l5 5","key":"svg-1"}],["path",{"d":"M12 4l0 12","key":"svg-2"}]]

/**
 * IconUpload
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdXBsb2FkIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDE3djJhMiAyIDAgMCAwIDIgMmgxMmEyIDIgMCAwIDAgMiAtMnYtMiIgLz4KICA8cGF0aCBkPSJNNyA5bDUgLTVsNSA1IiAvPgogIDxwYXRoIGQ9Ik0xMiA0bDAgMTIiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/upload
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconUpload = createReactComponent('outline', 'upload', 'Upload', __iconNode);

export default IconUpload;